module.exports = __webpack_public_path__ + "static/img/3-noinfo-aftersale.43b6251.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/3-noinfo-aftersale.png
// module id = 1332
// module chunks = 0